import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Appointment, DialogData, TutorialVideo } from '../../engine/models/models';
import { ContractService } from '../../services/contract.service';
import { Globals } from '../../services/globals';
import { environment } from '../../../environments/environment';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { VideoType } from '../../enum';
import { ClientConfiguratioService } from '../../services/client-configuration.service';


@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.css']
})
export class VideoComponent implements OnInit {
  currentUrl: any;
  loading = true;
  video: TutorialVideo;
  isFullPage: boolean;
  height = window.innerHeight;
  playBackValues = ['0.5', '1.0', '1.5', '2.0', '3.0', '5.0', '10.0'];
  constructor(private router: Router,
    public globals: Globals,
    private clientConfiguration: ClientConfiguratioService,
    public dialogRef: MatDialogRef<MatDialog>) {
    this.currentUrl = this.router.url;
    this.isFullPage = (this.currentUrl === '/video')
    let height = localStorage.getItem('windowHeight')
    if (height) {
      this.height = parseInt(height);
    }
  }

  formatUrl(relativeUrl: string) {
    // If the URL is null, simply return it.
    if (!relativeUrl) { return relativeUrl; }
    return `${relativeUrl}`;
  }

  ngOnInit(): void {
    if ((this.currentUrl === '/video')) {
      this.video = this.globals.appointment.tutorialVideos.find(x => x.videoType == VideoType.Introduction);
      this.video.disableClose = true;
    } else if (this.globals.selectedVideo) {
      this.video = this.globals.selectedVideo;
    }
  }

  videoCompleted() {
    if (this.currentUrl === '/video') {
      this.updateVideoWatched(this.video.videoType)
      this.globals.displayRooms = true;
      this.router.navigate(['/selections']);
    } else {
      this.updateVideoWatched(this.video.videoType);
      this.dialogRef.close();
      if (this.video.showNotifictaion) {
        this.globals.showNotificationPanel();
      }
    }
  }

  updateVideoWatched(videoType: VideoType) {
    if (this.video.disableClose) {
      let appointment = this.globals.appointment;
      //update on cloud
      this.clientConfiguration.updateVideoWatched(appointment.contractId, videoType).subscribe();
      var index = appointment.tutorialVideos.findIndex(x => x.videoType == videoType);
      if (index >= 0) {
        appointment.tutorialVideos[index].isWatched = true;
        this.globals.appointment = appointment
      }
    }
  }
}
